/**
 * Telepost Api
 * Для авторизации зайти http://local.telepost.me/  В `/etc/hosts` добавить запись  ```sh 127.0.0.1 local.telepost.me ``` При авторизации добавть `Bearer` перед токеном         
 *
 * OpenAPI spec version: 2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { MessageDefaultSettings } from '../model/messageDefaultSettings';
import { PostFormSettingsDto } from '../model/postFormSettingsDto';
import { SelfInfo } from '../model/selfInfo';
import { SetTimezoneDto } from '../model/setTimezoneDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UsersService {

    protected basePath = 'http://localhost/api';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get self info
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public me(observe?: 'body', reportProgress?: boolean): Observable<SelfInfo>;
    public me(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SelfInfo>>;
    public me(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SelfInfo>>;
    public me(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SelfInfo>(`${this.basePath}/users/me`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set post form settings
     * 
     * @param PostFormSettingsDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setPostFormSettings(PostFormSettingsDto: PostFormSettingsDto, observe?: 'body', reportProgress?: boolean): Observable<MessageDefaultSettings>;
    public setPostFormSettings(PostFormSettingsDto: PostFormSettingsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MessageDefaultSettings>>;
    public setPostFormSettings(PostFormSettingsDto: PostFormSettingsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MessageDefaultSettings>>;
    public setPostFormSettings(PostFormSettingsDto: PostFormSettingsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (PostFormSettingsDto === null || PostFormSettingsDto === undefined) {
            throw new Error('Required parameter PostFormSettingsDto was null or undefined when calling setPostFormSettings.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<MessageDefaultSettings>(`${this.basePath}/users/post-form-settings`,
            PostFormSettingsDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set user timezone
     * 
     * @param SetTimezoneDto 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setTimezone(SetTimezoneDto: SetTimezoneDto, observe?: 'body', reportProgress?: boolean): Observable<SelfInfo>;
    public setTimezone(SetTimezoneDto: SetTimezoneDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SelfInfo>>;
    public setTimezone(SetTimezoneDto: SetTimezoneDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SelfInfo>>;
    public setTimezone(SetTimezoneDto: SetTimezoneDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (SetTimezoneDto === null || SetTimezoneDto === undefined) {
            throw new Error('Required parameter SetTimezoneDto was null or undefined when calling setTimezone.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<SelfInfo>(`${this.basePath}/users/set-timezone`,
            SetTimezoneDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
